package org.dronda.app.web.ui.scaffolding

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import org.dronda.app.web.ui.util.rememberWindowSize
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.Main
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Scaffolding(
    modifier: Modifier = Modifier.fillMaxSize(),
    onLogoClick: (() -> Unit)? = null,
    onSettingsClick: (() -> Unit)? = null,
    content: @Composable ScaffoldingScope.() -> Unit
) {
    val windowSize by rememberWindowSize()
    val headerWidth by remember(windowSize) {
        mutableStateOf(
            if (windowSize.width > 800) {
                70.percent
            } else {
                90.percent
            }
        )
    }

    Column(
        modifier
            .fillMaxSize()
            .height(100.vh)
    ) {
        Header(
            Modifier.fillMaxWidth()
                .height(4.cssRem)
                .backgroundImage(
                    linearGradient(
                        LinearGradient.Direction.ToRight,
                    ) {
                        add(rgb(35, 0, 96), 50.percent)
                        add(rgb(13, 0, 35), 100.percent)
                    }
                )
                .display(DisplayStyle.Flex)
                .justifyContent(JustifyContent.Center)
                .toAttrs()
        ) {
            Row(
                Modifier.fillMaxSize()
                    .width(headerWidth),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                H1(
                    Modifier.fontSize(2.em)
                        .color(rgb(253, 232, 255))
                        .then(
                            if (onLogoClick != null) {
                                Modifier.cursor(Cursor.Pointer).onClick { onLogoClick() }
                            } else {
                                Modifier
                            }
                        )
                        .toAttrs()
                ) {
                    Text("dronda")
                }

                // Right side: Settings link
                if (onSettingsClick != null) {
                    Span(
                        Modifier
                            .fontSize(1.2.cssRem)
                            .color(rgb(253, 232, 255))
                            .cursor(Cursor.Pointer)
                            .onClick { onSettingsClick() }
                            .toAttrs {
                                style {
                                    property("transition", "opacity 0.2s ease")
                                }
                                onMouseEnter { it.currentTarget.asDynamic().style.opacity = "0.8" }
                                onMouseLeave { it.currentTarget.asDynamic().style.opacity = "1" }
                            }
                    ) {
                        Text("⚙️ Settings")
                    }
                }
            }
        }

        Main(Modifier.fillMaxSize().toAttrs()) {
            content(ScaffoldingScopeInstance)
        }
    }
}

interface ScaffoldingScope {
    fun Modifier.scaffoldingInsets() = this.padding(topBottom = 3.cssRem, leftRight = 8.cssRem)
}

private object ScaffoldingScopeInstance : ScaffoldingScope
